import React from 'react';

function PauseIcon(props) {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={38}
        height={38}
        fill="none"
        {...props}
    >
        <path fill="#fff" d="M38 0v38H0V0z" />
        <path fill="#474747" d="M21 11h4v17h-4V11ZM13 11h4v17h-4V11Z" />
    </svg>
  );
}

export default PauseIcon;